import React, { PropsWithChildren } from 'react';
import { layoutVerticalContentWrapperStyle } from './layout-content.styles.css';

type LayoutVerticalContentProps = {
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export const LayoutVerticalContent: React.FC<
    PropsWithChildren<LayoutVerticalContentProps>
> = ({ children, onClick }) => (
    <div className={layoutVerticalContentWrapperStyle} onClick={onClick}>
        {children}
    </div>
);
